import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import {
    BrandProfileAssetFilterInput,
    CreateBrandProfileAssetsBatchInput,
    UpdateBrandProfileAssetInput,
} from './inputs';
import { BrandProfileAssetRef, BrandProfileAssetRefList } from './refs';
import { BrandProfileAssetResource } from './resources';

export default class BrandProfileAsset {
    private basePath = '/api/brand-profile-asset';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get list of brand profile assets
    get = async (filter: BrandProfileAssetFilterInput): Promise<CollectionResource<BrandProfileAssetResource, {}>> => {
        const query = qs.stringify(filter);

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Get single brand profile asset
    getById = async (id: ID): Promise<BrandProfileAssetRefList> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);

        return data;
    };

    // Batch-create brand profile assets
    createBatch = async (input: CreateBrandProfileAssetsBatchInput): Promise<BrandProfileAssetRefList> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);

        return data;
    };

    // Update asset
    update = async (id: ID, input: UpdateBrandProfileAssetInput): Promise<BrandProfileAssetRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}`, input);

        return data;
    };

    // Archive brand profile asset
    archive = async (id: ID): Promise<BrandProfileAssetRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);

        return data;
    };

    // Restore archived brand profile asset
    restore = async (id: ID): Promise<BrandProfileAssetRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/restore`);

        return data;
    };
}
